module.exports = __webpack_public_path__ + "img/remove_icon.852c7d83.png";